// Tony & Charlie: 'Secure checkout'-label bij de betaallogo's (footer, productpagina) en in het winkelmandje.
// Klopt altijd: afrekenen gaat via de beveiligde Shopify-checkout (SSL).
document.addEventListener('DOMContentLoaded', function () {
  var TEXT = '<strong>Secure checkout</strong> · SSL-encrypted payments by Shopify';
  var LOCK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>';

  var style = document.createElement('style');
  style.textContent = '.tc-secure{display:flex;align-items:center;gap:8px;font-size:13px;line-height:1.4;color:var(--ink-soft);margin:0 0 10px}.tc-secure strong{color:var(--ink);font-weight:500}.tc-secure svg{flex:0 0 auto;color:var(--ink)}' +
    'footer .tc-secure{justify-content:flex-end}@media (max-width:700px){footer .tc-secure{justify-content:center}}' +
    '.cart-drawer-foot .tc-secure{justify-content:center;margin:12px 0 8px}.cart-drawer-foot .tc-payment-list{justify-content:center;gap:6px}.cart-drawer-foot .tc-payment-icon svg{width:34px;height:22px}';
  document.head.appendChild(style);

  function label() {
    var d = document.createElement('div');
    d.className = 'tc-secure';
    d.innerHTML = LOCK + '<span>' + TEXT + '</span>';
    return d;
  }

  // Footer
  var footerPay = document.querySelector('footer [data-tc-payments]');
  if (footerPay) { footerPay.insertBefore(label(), footerPay.firstChild); }

  // Productpagina (de logo's worden door tc-extras.js onder de wishlist-knop gezet)
  setTimeout(function () {
    var productPay = document.querySelector('.product-info .tc-payments');
    if (productPay && !productPay.querySelector('.tc-secure')) {
      productPay.insertBefore(label(), productPay.firstChild);
    }
  }, 0);

  // Winkelmandje-lade: label + kleine betaallogo's onder de Checkout-knop
  var foot = document.querySelector('.cart-drawer-foot');
  var checkoutForm = foot ? foot.querySelector('form') : null;
  if (foot && checkoutForm) {
    var wrap = document.createElement('div');
    wrap.className = 'tc-cart-secure';
    wrap.appendChild(label());
    if (footerPay) {
      var list = footerPay.querySelector('.tc-payment-list');
      if (list) { wrap.appendChild(list.cloneNode(true)); }
    }
    checkoutForm.parentNode.insertBefore(wrap, checkoutForm.nextSibling);
  }
});
